export default "__VITE_ASSET__770e80fd__"